export const globalDateFormat = `dd/MM/yyyy`
export const globalDateTimeFormat = `dd/MM/yyy HH:mm`
